import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError } from '../../data/actions';

/**
 * Organisation field wrapper.
 *
 * Handles value changes and error clearing.
 */
const Organisation = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const {
    value,
    handleChange,
    handleErrorChange,
  } = props;

  const handleOnChange = (event) => {
    let organisation = event.target.value;
    if (organisation.length > 30) {
      return;
    }
    if (organisation.startsWith(' ')) {
      organisation = organisation.trim();
    }
    handleChange({ target: { name: 'organisation', value: organisation } });
  };

  const handleOnFocus = (event) => {
    handleErrorChange('organisation', '');
    dispatch(clearRegistrationBackendError('organisation'));
  };

  return (
    <FormGroup
      {...props}
      handleChange={handleOnChange}
      handleFocus={handleOnFocus}
    />
  );
};

Organisation.defaultProps = {
  errorMessage: '',
  autoComplete: null,
};

Organisation.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
};

export default Organisation;
